/* Sharrow Prop Finder scripts (converted from Squarespace). */
(function(){
      const productUrls = {
        vx: (window.SHARROW_LINKS||{}).product_vx_pro,
        mx: (window.SHARROW_LINKS||{}).product_mx,
        mxv: (window.SHARROW_LINKS||{}).product_mx_v,
        mxa: (window.SHARROW_LINKS||{}).product_mx_a,
        x10: (window.SHARROW_LINKS||{}).product_x10,
        xo: (window.SHARROW_LINKS||{}).product_xo,
        ax: (window.SHARROW_LINKS||{}).product_ax,
        cx: (window.SHARROW_LINKS||{}).product_cx,
        mxs: (window.SHARROW_LINKS||{}).product_mx_s,
        mxp: (window.SHARROW_LINKS||{}).product_mx_a,
        veemSmall: (window.SHARROW_LINKS||{}).product_veem_26_55,
        review: (window.SHARROW_LINKS||{}).consultation_url
      };

      const products = {
        vx: { title: 'SHARROW VX-Pro™ for Wake, Ski, Tow', price: '$4,995', link: productUrls.vx, reason: 'Your setup points to a wake, surf, ski, or tow application. The VX-Pro is the Sharrow line built for faster hole-shot, smoother pull, quieter operation, and efficiency where watersports boats need it most.', bullets: ['Best for wake, surf, ski, and tow boats', 'Built to order in Detroit', 'Team confirms pitch and blade selection after order'] },
        mxPontoon: { title: 'SHARROW MX™', price: '$4,995', link: productUrls.mx, reason: 'Because you selected pontoon or tritoon, the Prop Finder is routing this recommendation to the SHARROW MX line. The Sharrow team will confirm the correct pitch, diameter, hub, and setup after the order.', bullets: ['Recommended MX path for pontoon and tritoon setups', 'Fitment review confirms pitch, diameter, hub, and rotation', 'Built to improve bite, control, efficiency, and smoothness'] },
        cx: { title: 'SHARROW CX™ Duo-Prop', price: 'From $8,995', link: productUrls.cx, reason: 'Your drive type points to a contra-rotating or duo-prop application. The CX is designed for duo-prop setups including Mercury V12, Bravo III, Volvo Sterndrive DuoProp, and Suzuki 300/350 applications.', bullets: ['For duo-prop / contra-rotating drives', 'Mercury, Volvo, and Suzuki applications', 'Team confirms pitch, diameter, and blade configuration'] },
        mxs: { title: 'SHARROW MX-S™ Sterndrive', price: '$4,995', link: productUrls.mxs, reason: 'Your setup points to a single-prop sterndrive. The MX-S is designed for popular sterndrives including MerCruiser Bravo 1, MerCruiser Alpha 1, Volvo SX, and OMC Cobra.', bullets: ['For sterndrives from 150HP to 500HP', 'Popular pitch and diameter combinations may ship quickly', 'Fitment review confirms rotation and setup'] },
        ax: { title: 'SHARROW AX™', price: 'From $795', link: productUrls.ax, reason: 'Your horsepower points to a small outboard, kicker, tender, trolling, or small aluminum fishing boat application. The AX is built for 6HP to 30HP outboards.', bullets: ['For 6HP to 30HP outboards', 'Strong for trolling control and low-speed maneuverability', 'Designed for small engines and auxiliary motors'] },
        mxa: { title: 'SHARROW MX-A™ Aluminum', price: 'From $1,595', link: productUrls.mxa, reason: 'Your horsepower and material preference point to the MX-A aluminum line. It is built for 40HP to 200HP outboards and is the more accessible aluminum option.', bullets: ['For 40HP to 200HP outboards', 'Aircraft-grade aluminum construction', 'Estimated shipping shown as 4–6 weeks on the product page'] },
        mxv: { title: 'SHARROW MX-V™ Stainless', price: 'From $2,795', link: productUrls.mxv, reason: 'Your horsepower points to a 70HP to 200HP outboard where stainless steel is a strong fit. The MX-V is the stainless line for L4, V4, 2-stroke, 4-stroke, command thrust, and power thrust motors.', bullets: ['For 70HP to 200HP outboards', 'Compatible with popular outboard brands', 'Stainless steel performance option'] },
        x10: { title: 'SHARROW X10™', price: '$5,995', link: productUrls.x10, reason: 'Your Mercury horsepower points to the V10 range. The X10 is specifically designed for Mercury V10 350 and 400 HP motors. If the customer has a Mercury V10 425, Sharrow should verify before ordering because the page lists 425 as a horsepower option while the description highlights 350 and 400.', bullets: ['For Mercury V10 applications', 'Best match for Mercury 350 and 400 V10', 'Fitment review recommended for Mercury 425'] },
        xo: { title: 'SHARROW XO™', price: '$5,995', link: productUrls.xo, reason: 'Your engine selection points to Yamaha 425/450 or Honda 350. The XO is specifically designed for those high-horsepower outboard applications.', bullets: ['For Yamaha 425 and 450 V8 motors', 'For Honda 350 motors', 'Sharrow confirms pitch and blade selection after order'] },
        mx: { title: 'SHARROW MX™', price: '$4,995', link: productUrls.mx, reason: 'Your setup points to the core Sharrow MX line for 200HP to 450HP outboards. This is the main stainless-steel outboard product for many Mercury, Yamaha, Honda, OXE, COX, Suzuki, and Evinrude applications.', bullets: ['For 200HP to 450HP outboards', 'Popular pitch and diameter combinations may be in stock', 'Strong general match for offshore and recreational outboards'] },
        review: { title: 'Schedule a Sharrow Fitment Call', price: 'Free fitment review', link: productUrls.review, reason: 'We recommend a quick call or appointment with a Sharrow specialist so we can confirm the right propeller for your exact boat, engine, and performance goals.', bullets: ['Book an appointment with the Sharrow team', 'We will review your setup and recommend the correct product line', 'A specialist will confirm pitch, diameter, and fitment before you order'] }
      };

      let step = 0;
      const answers = {};
      const steps = Array.from(document.querySelectorAll('.sf-step'));
      const progress = document.getElementById('sfProgress');
      const resultWrap = document.getElementById('sfResultWrap');
      const form = document.getElementById('sfForm');

      function showStep(i){
        step = Math.max(0, Math.min(i, steps.length - 1));
        steps.forEach((s, idx) => s.classList.toggle('active', idx === step));
        progress.style.setProperty('width', `${((step + 1) / steps.length) * 100}%`, 'important');
      }

      function titleCase(value){
        if(!value) return 'Not provided';
        return String(value).replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      }

      function collectFields(){
        ['manufacturer','horsepower','engineCount','materialPref','diameter','pitch','currentProp','boatDetails'].forEach(id => {
          const el = document.getElementById(id);
          if(el) answers[id] = el.value;
        });
      }

      function chooseProduct(){
        collectFields();
        const hp = parseInt(answers.horsepower, 10) || 0;
        const maker = (answers.manufacturer || '').toLowerCase();
        const boat = answers.boatType;
        const drive = answers.driveType;
        const material = answers.materialPref;

        if (boat === 'wake' || drive === 'inboard') return products.vx;
        if (boat === 'pontoon') return products.mxPontoon;
        if (drive === 'duoprop') return products.cx;
        if (boat === 'sterndrive' || drive === 'sterndrive') return products.mxs;
        if (boat === 'commercial') return products.review;
        if (hp >= 6 && hp <= 30) return products.ax;
        if (hp >= 40 && hp <= 69) return products.mxa;
        if (hp >= 70 && hp <= 200) {
          if (material === 'stainless') return products.mxv;
          if (material === 'aluminum') return products.mxa;
          return products.mxv;
        }
        if (maker === 'mercury' && (hp === 350 || hp === 400 || hp === 425)) return products.x10;
        if ((maker === 'yamaha' && (hp === 425 || hp === 450)) || (maker === 'honda' && hp === 350)) return products.xo;
        if (hp >= 200 && hp <= 450) return products.mx;
        return products.review;
      }

      function renderResult(){
        const p = chooseProduct();
        form.style.display = 'none';
        resultWrap.classList.add('active');
        progress.style.setProperty('width', '100%', 'important');
        document.getElementById('sfProductTitle').textContent = p.title;
        document.getElementById('sfPrice').textContent = p.price;
        document.getElementById('sfReason').textContent = p.reason;
        document.getElementById('sfProductLink').href = p.link;
        document.getElementById('sfProductLink').textContent = p.title === 'Schedule a Sharrow Fitment Call' ? 'Book Appointment' : 'View Product';
        const bullets = document.getElementById('sfBullets');
        bullets.innerHTML = '';
        p.bullets.forEach(b => { const li = document.createElement('li'); li.textContent = b; bullets.appendChild(li); });
        const summary = document.getElementById('sfSummary');
        summary.innerHTML = '';
        const fields = [
          ['Goal', answers.goal], ['Boat Type', answers.boatType], ['Drive Type', answers.driveType], ['Manufacturer', answers.manufacturer], ['HP Per Engine', answers.horsepower], ['Number of Engines', answers.engineCount], ['Material Preference', answers.materialPref], ['Boat', answers.boatDetails], ['Current Prop', answers.currentProp], ['Diameter', answers.diameter], ['Pitch', answers.pitch]
        ];
        fields.forEach(([k,v]) => {
          const row = document.createElement('div'); row.className = 'sf-summary-item';
          row.innerHTML = `<span>${k}</span><span>${titleCase(v)}</span>`;
          summary.appendChild(row);
        });
      }

      document.querySelectorAll('.sf-options').forEach(group => {
        group.addEventListener('click', e => {
          const btn = e.target.closest('.sf-option');
          if(!btn) return;
          const name = group.dataset.name;
          answers[name] = btn.dataset.value;
          group.querySelectorAll('.sf-option').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          setTimeout(() => showStep(step + 1), 130);
        });
      });

      document.querySelectorAll('[data-back]').forEach(btn => btn.addEventListener('click', () => showStep(step - 1)));
      document.querySelectorAll('[data-next]').forEach(btn => btn.addEventListener('click', () => showStep(step + 1)));
      document.getElementById('sfRecommend').addEventListener('click', renderResult);
      document.getElementById('sfRestart').addEventListener('click', () => {
        Object.keys(answers).forEach(k => delete answers[k]);
        document.querySelectorAll('.sf-option').forEach(b => b.classList.remove('selected'));
        document.querySelectorAll('input, textarea').forEach(i => i.value = '');
        document.querySelectorAll('select').forEach(s => s.selectedIndex = 0);
        form.style.display = 'block';
        resultWrap.classList.remove('active');
        showStep(0);
      });

      showStep(0);
    })();
  


async function sendToSharrow(){

  const portalId="9054659";
  const formGuid="83832cca-7b42-4098-b4de-c107d4878c1e";

  const name=document.getElementById('sfLeadName').value||'';
  const email=document.getElementById('sfLeadEmail').value||'';
  const phone=document.getElementById('sfLeadPhone').value||'';

  const recommended=document.getElementById('sfProductTitle')?.textContent||'';

  const getSummary=(label)=>{
    const rows=document.querySelectorAll('.sf-summary-item');
    for(const r of rows){
      const s=r.querySelectorAll('span');
      if(s[0]?.textContent===label){return s[1]?.textContent||'';}
    }
    return '';
  };

  const payload={
    fields:[
      {name:"firstname",value:name},
      {name:"email",value:email},
      {name:"phone",value:phone},
      {name:"recommended_propeller",value:recommended},
      {name:"prop_finder_goal",value:getSummary("Goal")},
      {name:"boat_type",value:getSummary("Boat Type")},
      {name:"drive_type",value:getSummary("Drive Type")},
      {name:"engine_manufacturer",value:getSummary("Manufacturer")},
      {name:"horsepower",value:getSummary("HP Per Engine")},
      {name:"engine_count",value:getSummary("Number of Engines")},
      {name:"boat_make_model",value:getSummary("Boat")},
      {name:"current_prop",value:getSummary("Current Prop")},
      {name:"current_diameter",value:getSummary("Diameter")},
      {name:"current_pitch",value:getSummary("Pitch")}
    ],
    context:{
      pageUri:window.location.href,
      pageName:document.title
    }
  };

  try{
    const res=await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify(payload)
    });

    if(res.ok){
      const confirm=document.getElementById("sfSubmitConfirmation");
      if(confirm){confirm.style.display="block";}
    }else{
      alert("Submission failed. Please call Sharrow or try again.");
    }

  }catch(e){
    alert("Submission error. Please call Sharrow.");
  }

}
